/*
 * @FilePath: /www.feimaoyun.com_html_reconfiguration/src/utils/secretkey/p.js
 * @Description: 浏览器指纹加密的密钥
 */
export default 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIBI+1eO2zaS1kpyy4f3tRxHOb5gUFWV5ecA7bhKHtkszrEg1+eNBhBxGXfVSj4D9N/Pq1+cHbqxWfJPeg3Rc/j6hEr11kHimC6wqB9WtT8eCYtuo/UGFEi37YREKRdf5g3tdysFdnEBOWxgdQOJ76qrRaxVWOaw/3Ih31eDO8VQIDAQAB'
